import { createSelector } from 'reselect'

const getFetchSchoolRequest = state => state.School.fetchSchoolRequest
const getUpdateSchoolRequest = state => state.School.updateAccountRequest
const getUploadAvatarRequest = state => state.School.uploadAvatarRequest
const getRemoveAvatarRequest = state => state.School.removeAvatarRequest

const getUploadCoverRequest = state => state.School.uploadCoverRequest
const getRemoveCoverRequest = state => state.School.removeCoverRequest

const getSchool = state => state.School.school

const getSchoolAvatar = createSelector(
  [getSchool],
  school => (!school ? null : school.avatar)
)

export {
  getFetchSchoolRequest,
  getSchoolAvatar,
  getSchool,
  getUpdateSchoolRequest,
  getUploadAvatarRequest,
  getRemoveAvatarRequest,
  getUploadCoverRequest,
  getRemoveCoverRequest
}
